/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Erklaerungstrafverfahrenid3Inputs */



/**

* @param {_Field_Erklaerungstrafverfahrenid3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_erklaerungstrafverfahrenid3 = /** @type {((inputs?: _Field_Erklaerungstrafverfahrenid3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Erklaerungstrafverfahrenid3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Erklärung Strafverfahren")
});
export { _field_erklaerungstrafverfahrenid3 as "_field_erklaerungStrafverfahrenID" }